import { render, staticRenderFns } from "./DeliverList.vue?vue&type=template&id=5980879f&scoped=true&"
import script from "./DeliverList.vue?vue&type=script&lang=js&"
export * from "./DeliverList.vue?vue&type=script&lang=js&"
import style0 from "./DeliverList.vue?vue&type=style&index=0&id=5980879f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5980879f",
  null
  
)

export default component.exports